function validateNonAuth(values) {
  let errors = {};
  if (!values.author) {
    errors.author = "Please enter your name.";
  }
  if (!values.quoteComment) {
    errors.quoteComment = "Please enter a comment.";
  }
  return errors;
}

// Errors for Chimney logged in users
function validateAuth(values) {
  let errors = {};
  if (!values.quoteComment) {
    errors.quoteComment = "Please enter a comment. Thanks.";
  }
  return errors;
}

export { validateNonAuth, validateAuth };
